/**
 * Normalize language codes to BCP 47 standard.
 * Corrects common invalid variants like "kg" → "ky", "uig" → "ug", etc.
 */

const validBCP47Codes = new Set([
  'tr',
  'en',
  'ar',
  'es',
  'fa',
  'fr',
  'de',
  'ru',
  'mk',
  'sq',
  'sw',
  'ha',
  'pcm',
  'so',
  'ur',
  'uz',
  'ug',
  'tk',
  'tt',
  'ro',
  'pt',
  'ps',
  'ky',
  'kk',
  'it',
  'hu',
  'el',
  'ka',
  'fa-AF',
  'zh',
  'bg',
  'az',
  'hy',
  'ja',
  'no',
  'da',
  'pl',
  'fi',
  'id',
  'ms',
  'nl',
  'sv',
  'ko',
  'he',
  'en-AF',
  'fr-AF',
]);

const bcp47Corrections: Record<string, string> = {
  kg: 'ky', // Kyrgyz
  uig: 'ug', // Uyghur
  tuk: 'tk', // Turkmen
  tat: 'tt', // Tatar
  'en-af': 'en-AF', // English (Africa)
  'fr-af': 'fr-AF', // French (Africa)
};

export function normalizeLanguageCode(code: string): string {
  // Trim and normalize casing
  const normalized = code.trim();

  // If exact match exists
  if (validBCP47Codes.has(normalized)) return normalized;

  // If correction rule applies
  if (bcp47Corrections[normalized]) {
    return bcp47Corrections[normalized];
  }

  // If region separator is lowercase, fix it (e.g., en-af → en-AF)
  if (/^[a-z]{2,3}-[a-z]{2,3}$/.test(normalized)) {
    const [lang, region] = normalized.split('-');
    return `${lang}-${region.toUpperCase()}`;
  }

  console.warn(`⚠️ Unknown or non-standard language code: "${code}"`);
  return normalized;
}
